import { render, staticRenderFns } from "./about_feature.vue?vue&type=template&id=8a3823bc&scoped=true&"
import script from "./about_feature.vue?vue&type=script&lang=js&"
export * from "./about_feature.vue?vue&type=script&lang=js&"
import style0 from "./about_feature.vue?vue&type=style&index=0&id=8a3823bc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a3823bc",
  null
  
)

component.options.__file = "about_feature.vue"
export default component.exports